/*USER LIST*/
Vue.component('activity_manager', {
    template:'#activitymanager-template',

    data:function(){
        return{
            list: [],
            searchString:'',
            modal:'',
        };
    },
    created:function(){

        activeInstance = this;


        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/activites/list',function(response){
            $('body').LoadingOverlay("hide");

            activeInstance.list=response;

            setTimeout(function(){
                var $table = $('.fixed_header_table');
                $table.floatThead({
                    top:70
                });

/*
                setTimeout(function(){
                    var $table = $('.fixed_header_table');
                    $table.floatThead({
                        top:65
                    });
                },200);
*/

            },200);

        }).bind(this);
    },
    methods:{
        checkboxChanged: function(activity) {
            var state_str = (activity.enabled) ? 'aktiválni' : 'deaktiválni';


            bootbox.confirm({
                message: "Biztosan " + state_str + " szeretnéd a(z) " + activity.name + " tevékenységet?",
                buttons: {
                    confirm: {
                        label: 'Igen',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Mégsem',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        axios.post(baseURL + '/admin/activity/set_status', {id: activity.id, enabled: activity.enabled}).then(function(response) {
                            activity.enabled = activity.enabled;
                        }).catch(function(error) {
                            console.log(error);
                        });
                    } else {
                        activity.enabled = !activity.enabled;
                    }
                }
            });
        },
        create: function() {
            bootbox.prompt({
                title: 'Tevékenység létrehozása',
                callback: function(result) {
                    if (result) {
                        axios.post(baseURL + '/admin/activity/create', {name: result}).then(function(response) {
                            activeInstance.list.push(response.data);
                        }).catch(function(error) {
                            console.log(error);
                        });
                    }
                }
            });
        },
        edit:function(activity) {
            bootbox.prompt({
                title: activity.name + " - tevékenység módosítása",
                value: activity.name,
                callback: function(result) {
                    if (result) {
                        axios.post(baseURL + '/admin/activity/update', {id: activity.id, name: result, enabled: 1}).then(function(response) {
                            activity.name = result;
                        }).catch(function(error) {
                            console.log(error);
                        });
                    }
                }
            });
        },
        destroy:function(user){
            bootbox.confirm('Biztosan el akarod távolítani ezt a felhasználót?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/user/destroy',{user:user}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A felhasználó törölve.');
                        activeInstance.list.$remove(user);
                    });
                }
            });
        }
    }
});